<template>
  <div>
    <h5>{{ name }}</h5>
  </div>
</template>

<script>

export default {
  name: 'OrdersTableCellName',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    name: {
      get () {
        return this.row.info.name || `#${this.row.info.number}`
      }
    }
  },
  components: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrdersTableCellName.vue